import React from "react";
import { Backdrop, Box, Fade, Modal } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { Button } from "@material-tailwind/react";
import { FiEye, FiEyeOff } from "react-icons/fi";

function AddAdmin(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: "45px",
    outline: "none",
    borderRadius: "35px",
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open}
        // onClose={props.onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <div className="flex justify-between items-center">
              <p className="font-bold text-5xl text-black">
                {props.modal?.update_admin
                  ? "Update"
                  : props.modal?.add_admin
                  ? "Add"
                  : ""}{" "}
                Admin
              </p>
              <IoClose
                className="cursor-pointer border border-[#BDBDBD] rounded-full absolute right-6 top-8 text-[#BDBDBD]"
                onClick={props.onClose}
              />
            </div>
            <form
              onSubmit={
                props.modal?.update_admin
                  ? props.handleUpdateSubmit
                  : props.handleAddSubmit
              }
              className="mt-3 w-[300px] sm:w-[400px] flex flex-col gap-3"
            >
              {/* {props.modal.add_admin && (
                <ReactSelect
                  value={props.selectedRoleOption}
                  onChange={props.setSelectedRoleOption}
                  options={SUPER_ROLE}
                  className="custom-select"
                  placeholder="Select a Role..."
                  required
                />
              )} */}
              <input
                className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                type="text"
                name="full_name"
                placeholder="Full Name *"
                onChange={props.handleChange}
                value={props.fieldData?.full_name}
                required
              />
              <input
                className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                type="tel"
                name="phone"
                placeholder="Phone no. *"
                onChange={props.handleChange}
                value={props.fieldData?.phone}
                maxLength={10}
                required
              />
              <input
                className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                type="email"
                name="email"
                placeholder="Email ID *"
                onChange={props.handleChange}
                value={props.fieldData?.email}
                required
              />
              {props.modal.add_admin && (
                <div className="relative">
                  <input
                    className="w-full bg-[#F5F7F9] pl-7 pr-12 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                    type={props.isPasswordVisible ? "text" : "password"}
                    name="password"
                    placeholder="Password *"
                    onChange={props.handleChange}
                    value={props.fieldData?.password}
                    required
                  />
                  {props.isPasswordVisible ? (
                    <FiEyeOff
                      onClick={props.togglePasswordVisibility}
                      className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
                    />
                  ) : (
                    <FiEye
                      onClick={props.togglePasswordVisibility}
                      className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
                    />
                  )}
                </div>
              )}
              <Button
                type="submit"
                disabled={props.loading?.btn}
                className="mt-2 rounded-2xl bg-[#03438D] px-7 py-6 tracking-widest font-poppins font-light text-lg outline-none"
              >
                {props.loading?.btn ? "Loading..." : "Continue"}
              </Button>
            </form>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default AddAdmin;
